var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftmsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3002",
    "data-name": "Group 3002",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.001,
    height: 18.001,
    viewBox: "0 0 18.001 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M14.251,91.333a.75.75,0,0,0-.75.75v6a.751.751,0,0,1-.75.75H2.25a.751.751,0,0,1-.75-.75v-10.5a.751.751,0,0,1,.75-.75h6a.75.75,0,0,0,0-1.5h-6A2.253,2.253,0,0,0,0,87.583v10.5a2.253,2.253,0,0,0,2.25,2.25h10.5A2.253,2.253,0,0,0,15,98.084v-6A.749.749,0,0,0,14.251,91.333Z",
    transform: "translate(0 -82.333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M182.448,73.71a.38.38,0,0,0-.1.191l-.53,2.652a.375.375,0,0,0,.368.449.356.356,0,0,0,.074-.007l2.651-.53a.373.373,0,0,0,.192-.1l5.934-5.934-2.651-2.651Z",
    transform: "translate(-175.416 -65.393)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M395.135.564a1.876,1.876,0,0,0-2.651,0L391.445,1.6,394.1,4.254l1.038-1.038a1.875,1.875,0,0,0,0-2.651Z",
    transform: "translate(-377.682 -0.016)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftmsg);
export default __webpack_public_path__ + "static/media/draftmsg.2bdfa16c00af08534fd4ee27b53e55c0.svg";
export { ForwardRef as ReactComponent };